<template>
	<header class="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
		<div class="container px-4 mx-auto">
			<div class="flex items-center justify-between h-16">
				<!-- Logo/Brand -->
				<router-link
					to="/"
					class="flex items-center gap-3 px-2 -ml-2 transition-all duration-200 rounded-lg hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
					title="Zur Startseite"
					aria-label="Schule Leichter - Zur Startseite"
				>
					<img :src="LogoSvg" alt="Schule Leichter Logo" class="w-35" />
				</router-link>

				<!-- Optional Right Content Slot -->
				<div v-if="$slots.right" class="flex items-center gap-2">
					<slot name="right" />
				</div>
			</div>
		</div>
	</header>
</template>

<script setup lang="ts">
import LogoSvg from '@/assets/logo.svg?url';
</script>

<style scoped>
/* Ensure smooth transitions */
</style>
